<template>
  <section class="container">
    <h1 class="title">
      Sorry~
    </h1>
    <p class="info">系统跟您开了个小差，攻城狮们正在紧急处理<br>请稍后再试</p>
  </section>
</template>
<script>
export default {
  props: ['error'],
  async asyncData (ctx) {
    ctx.redirect("/");
  }
}
</script>

<style scoped>
  .container{
    text-align: center;
  }
.title
{
  font-size: 0.4rem;
  width: 90%;
  margin: 1rem auto;
  text-align: center;
  color: red;
}
.info{
  font-size: 14px;
  color: #b9b9b9;
  width: 90%;
  margin: 1rem auto;
  text-align: center;
}
.button
{
  font-size: 16px;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// layouts/error.vue